<template>
  <select
    class="tw-w-full tw-px-2 tw-py-1 tw-border tw-rounded tw-text-sm"
    v-model="localAmountToUse"
    @change="handleChange"
  >
    <option value="gross_amount">
      {{ t('sepa.titles.gross_amount') }}
    </option>
    <option :disabled="!hasAmountWithoutDiscount" value="gross_amount_without_discount">
      {{ t('sepa.titles.amount_without_discount') }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  payment: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['amount-to-use-changed']);

const localAmountToUse = ref(props.payment.amount_to_use || 'gross_amount');

const hasAmountWithoutDiscount = computed(() => {
  return (
    props.payment.gross_eur_less_discount !== null &&
    Number(props.payment.gross_eur_less_discount) !== 0
  );
});

const handleChange = () => {
  emit('amount-to-use-changed', props.payment.id, localAmountToUse.value);
};

watch(
  () => props.payment.amount_to_use,
  newValue => {
    localAmountToUse.value = newValue || 'gross_amount';
  }
);
</script>
